import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-187e6f72")

_pushScopeId("data-v-187e6f72")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "mar-r-8 mar-t-12" }, "选择门店", -1)
const _hoisted_4 = { class: "flex button-group alignC flexC" }
const _hoisted_5 = { class: "flex flexR mar-t-22" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        modelValue: _ctx.screenParameter.store_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.store_id = $event)),
        onChange: _ctx.getTableData,
        placeholder: "请选择",
        class: "mar-t-12",
        filterable: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.storeList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.store_name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_input, {
        style: {"width":"202px"},
        modelValue: _ctx.screenParameter.search,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenParameter.search = $event)),
        placeholder: "项目名称",
        clearable: "",
        "suffix-icon": "el-icon-search",
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectChange($event,'search'))),
        class: "mar-t-12 mar-l-12"
      }, null, 8, ["modelValue"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "推荐",
          align: "center",
          "min-width": "200"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_el_switch, {
                modelValue: scope.row.is_recommend,
                "onUpdate:modelValue": ($event: any) => (scope.row.is_recommend = $event),
                "active-value": 1,
                "active-color": "#F03037",
                "inactive-value": 0,
                "inactive-color": "#909399",
                onChange: ($event: any) => (_ctx.columnChange($event,scope.row.id))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
})